import * as AF from "@/components/form-items/AbstractForm";
import { GuidedScrollArea } from "@/components/ui/guided-scroll-area";
import { ScrollBar } from "@/components/ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { MonetaryTransactionList } from "../../../../components/form-items/FinancialMonitoring";

const financialTabs = [
  "production",
  "transport",
  "restoration",
  "framing",
  "photo",
  "expertise",
  "insurance",
];

export const ArtworkFinancialMonitoringTab = ({
  relatedArtworkId,
}: {
  relatedArtworkId: string;
}) => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState("estimate");
  const [searchParams, setSearchParam] = useSearchParams();

  useEffect(() => {
    const view = searchParams.get("financial-tab");

    if (view == null) {
      setActiveTab("estimate");
      return;
    }
    setActiveTab(view);
  }, [searchParams, setActiveTab]);

  return (
    <Tabs
      className="w-full"
      value={activeTab}
      onValueChange={(val) => {
        setActiveTab(val);
        searchParams.set("financial-tab", val);
        setSearchParam(searchParams);
      }}
    >
      <div className="flex flex-col gap-8 w-full">
        <TabsList className="w-full">
          <GuidedScrollArea>
            <div className="flex flex-nowrap">
              <TabsTrigger value="estimate">
                {t("tab_suiviFinancier_estimate")}
              </TabsTrigger>
              <TabsTrigger value="disposition">
                {t("tab_suiviFinancier_disposition")}
              </TabsTrigger>
              <TabsTrigger value="acquisition">
                {t("tab_suiviFinancier_acquisition")}
              </TabsTrigger>
              {financialTabs.map((tab) => (
                <TabsTrigger key={tab} value={tab}>
                  {t(`tab_suiviFinancier_${tab}`)}
                </TabsTrigger>
              ))}
              <TabsTrigger value="notes">
                {t("tab_suiviFinancier_notes")}
              </TabsTrigger>
            </div>
            <ScrollBar orientation="horizontal" />
          </GuidedScrollArea>
        </TabsList>
        <div className="max-w-xl">
          <TabsContent value="estimate">
            <MonetaryTransactionList
              category="estimate"
              relatedArtworkId={relatedArtworkId}
            />
          </TabsContent>
          <TabsContent value="acquisition">
            <AF.Col>
              <AF.Text name="oeuvreAchatTitre" />
              <AF.Row>
                <AF.Text name="oeuvreAchatDate" />
                <AF.SelectCurrency
                  className="w-full"
                  name="oeuvreAchatMontant"
                />
              </AF.Row>
              <AF.Row>
                <AF.SelectCurrency
                  className="w-full"
                  name="oeuvreAchatMontantTVA"
                />
                <AF.SelectCurrency
                  className="w-full"
                  name="oeuvreAchatMontantDroitsDeDouane"
                />
              </AF.Row>
              <AF.Row>
                <AF.SelectCurrency
                  className="w-full"
                  name="oeuvreAchatMontantDroitsDeSuite"
                />
                <AF.SelectCurrency
                  className="w-full"
                  name="oeuvreAchatMontantFraisDeVente"
                />
              </AF.Row>
            </AF.Col>
          </TabsContent>
          <TabsContent value="disposition">
            <AF.Col>
              <AF.Text name="oeuvreVenteTitre" />
              <AF.Row>
                <AF.Text name="oeuvreVenteDate" />
                <AF.SelectCurrency
                  className="w-full"
                  name="oeuvreVenteMontant"
                />
              </AF.Row>
              <AF.Row>
                <AF.SelectCurrency name="oeuvreVenteMontantTVA" />
                <AF.SelectCurrency name="oeuvreVenteMontantTOP" />
              </AF.Row>
            </AF.Col>
          </TabsContent>

          <TabsContent value="notes">
            <AF.Col>
              <AF.RichText name="oeuvreSuiviFinancierNotes" />
            </AF.Col>
          </TabsContent>
          {financialTabs.map((tab) => (
            <TabsContent key={tab} value={tab}>
              <MonetaryTransactionList
                category={tab}
                relatedArtworkId={relatedArtworkId}
              />
            </TabsContent>
          ))}
        </div>
      </div>
    </Tabs>
  );
};
